import React, { useState } from 'react';
import { useModalDismiss } from '../../hooks/useModalDismiss';

interface RenameImportBookModalProps {
  originalTitle: string;
  existingTitles: string[];
  onConfirm: (newTitle: string) => void;
  onCancel: () => void;
}

export function RenameImportBookModal({ originalTitle, existingTitles, onConfirm, onCancel }: RenameImportBookModalProps) {
  const [newTitle, setNewTitle] = useState(originalTitle);
  const [error, setError] = useState('');
  const dismiss = useModalDismiss(onCancel);

  const handleConfirm = () => {
    const trimmedTitle = newTitle.trim();
    if (!trimmedTitle) {
      setError('作品名称不能为空');
      return;
    }
    if (existingTitles.includes(trimmedTitle)) {
      setError('此名称已存在，请选择其他名称');
      return;
    }
    onConfirm(trimmedTitle);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleConfirm();
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'var(--modal-mask)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1001,
      backdropFilter: 'blur(4px)'
    }} {...dismiss}>
      <div style={{
        backgroundColor: 'var(--card-bg)', padding: 32, borderRadius: 24, width: 460,
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', color: 'var(--text-color)'
      }}>
        <h2 style={{ marginBottom: 12, fontSize: 18, fontWeight: 800 }}>更改作品名称</h2>
        <p style={{ marginBottom: 20, color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.6 }}>
          原名称：<span style={{ color: 'var(--primary-color)', fontWeight: 500 }}>{originalTitle}</span>
        </p>
        <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 10, fontWeight: 600 }}>
          新名称
        </label>
        <input
          type="text"
          autoFocus
          value={newTitle}
          onChange={(e) => { setNewTitle(e.target.value); setError(''); }}
          onKeyPress={handleKeyPress}
          placeholder="请输入新的作品名称"
          style={{
            width: '100%', padding: '14px 18px', marginBottom: error ? 8 : 24, boxSizing: 'border-box',
            border: error ? '2px solid var(--danger-color)' : '2px solid var(--border-color)',
            backgroundColor: 'var(--bg-color)', color: 'var(--text-color)',
            borderRadius: 12, fontSize: 16, transition: 'border-color 0.2s'
          }}
        />
        {error && (
          <div style={{ color: 'var(--danger-color)', marginBottom: 16, fontSize: 13, fontWeight: 600 }}>
            {error}
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <button
            onClick={onCancel}
            style={{
              padding: '12px 24px', backgroundColor: 'transparent', color: 'var(--text-secondary)',
              border: 'none', borderRadius: 12, cursor: 'pointer', fontSize: 15, fontWeight: 600
            }}
          >
            取消
          </button>
          <button
            onClick={handleConfirm}
            style={{
              padding: '12px 32px', backgroundColor: 'var(--primary-color)', color: 'white',
              border: 'none', borderRadius: 12, cursor: 'pointer', fontSize: 15, fontWeight: 700,
              boxShadow: '0 10px 15px -3px rgba(24, 144, 255, 0.4)'
            }}
          >
            确认导入
          </button>
        </div>
      </div>
    </div>
  );
}
